/**
 * Reusable component representing a list item with a message
 * using the subtitle style.
 */

import * as React from 'react'

import ComponentListCell from '@doordash/component-list-cell'
import { Text } from '@doordash/design-language'

type ListCellMessageProps = {
  text: string
}

export const ListCellMessage: React.FC<ListCellMessageProps> = props => (
  <ComponentListCell
    secondaryTitleStart={
      <Text styles={Text.Styles.SectionSubtext}>{props.text}</Text>
    }
    size={ComponentListCell.Sizes.Small}
    separatorType={ComponentListCell.SeparatorTypes.FullBorder}
    {...props}
  />
)

export default ListCellMessage
